/** Shared labels for a building data pack save/send log. */

export function formatPackWhen(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v).slice(0, 16);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function packOutcomeLabel(outcome) {
  if (outcome === 'both') return 'Saved and sent';
  if (outcome === 'sent') return 'Sent';
  return 'Saved';
}

/** Honest receipt: opened time, sent-but-not-opened, or not sent. */
export function packReceiptLabel(row) {
  if (!row) return '—';
  if (row.opened_at) return `Opened ${formatPackWhen(row.opened_at)}`;
  if (row.mail_status === 'stubbed') return 'Email not delivered — not opened';
  if (row.outcome === 'both' || row.outcome === 'sent' || row.mailed) return 'Sent — not opened';
  return 'Not sent';
}
